/**
 * @generated SignedSource<<ca15791491e6f9cbf03ff05abad6b6b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemHomeV2AroundSCMPQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeAroundMorningStudioPrimaryV2ContentItemContent" | "homeAroundMorningStudioSecondaryV2ContentItemContent" | "homeAroundPrimaryV2ContentItemContent" | "homeAroundSecondaryV2ContentItemContent">;
  };
  readonly " $fragmentType": "itemHomeV2AroundSCMPQueueItemsEdge";
}>;
export type itemHomeV2AroundSCMPQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: itemHomeV2AroundSCMPQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemHomeV2AroundSCMPQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "itemHomeV2AroundSCMPQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundMorningStudioPrimaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundMorningStudioSecondaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundPrimaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeAroundSecondaryV2ContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "fcebd7f3803a5d2bb76022cb1ffd859d";

export default node;
